import Super from '../../core/button.gjs';
import styles from './negative.module.scss';

export default class SpdsActionButtonNegative extends Super {
  baseClass = 'spds-button spds-action-button';
  hasBorder = true;
  variantClass = 'spds-action-button-negative';
  variantStyles = styles;
}
